import React from "react";

import AdminDashboard from "./AdminDashboard";
import AdminLogout from "./AdminLogout";
import AdminOrders from "./orders/AdminOrders";
import AdminCartSettings from "./AdminCartSettings";
import AdminPickupSettings from "./AdminPickupSettings";
import AdminFavicons from "./AdminFavicons";
import AdminMerchantSettings from "./merchant/AdminMerchantSettings";

import AdminProduct from "./products/AdminProduct";
import AdminCategories from "./categories/AdminCategories";
import AdminCategorySort from "./categories-sort/AdminCategorySort";

import AdminProductPrices from "./AdminProductPrices";
import AdminPromotions from "./promotions/AdminPromotions";
import AdminDiscounts from "./discounts/AdminDiscounts";

import AdminStoreLocation from "./store-locations/AdminStoreLocation";

import AdminPageContents from "./pages/AdminPageContents";
import AdminNotices from "./AdminNotices";
import AdminBanners from "./banners/AdminBanners";
import AdminBannersSort from "./banners-sort/AdminBannerSort";
import AdminPromos from "./AdminPromos";
import AdminReceiptOptions from "./AdminReceiptOptions";
import AdminTaxes from "./taxes/AdminTaxes";

export default [
	{
		path: "/admin",
		exact: true,
		render: props => <AdminDashboard {...props} />
	},
	{
		path: "/admin/logout",
		component: AdminLogout
	},
	{
		path: "/admin/view-orders",
		component: AdminOrders
	},
	{
		path: "/admin/settings",
		component: AdminCartSettings
	},
	{
		path: "/admin/pickup",
		component: AdminPickupSettings
	},
	{
		path: "/admin/merchant",
		component: AdminMerchantSettings
	},
	{
		path: "/admin/favicon",
		component: AdminFavicons
	},

	// Products
	{
		path: "/admin/products/add",
		component: AdminProduct
	},
	{
		path: "/admin/products/edit",
		component: AdminProduct
	},
	{
		path: "/admin/categories/add",
		component: AdminCategories
	},
	{
		path: "/admin/categories/edit",
		component: AdminCategories
	},
	{
		path: "/admin/categories/sort",
		component: AdminCategorySort
	},

	// Pricing
	{
		path: "/admin/prices",
		component: AdminProductPrices
	},
	{
		path: "/admin/promotions",
		component: AdminPromotions
	},
	{
		path: "/admin/discounts",
		component: AdminDiscounts
	},

	// Locations
	{
		path: "/admin/store-locations/add",
		component: AdminStoreLocation
	},
	{
		path: "/admin/store-locations/edit",
		component: AdminStoreLocation
	},

	// Misc
	{
		path: "/admin/pages",
		component: AdminPageContents
	},
	{
		path: "/admin/notices",
		component: AdminNotices
	},
	{
		path: "/admin/banners/order",
		component: AdminBannersSort
	},
	{
		path: "/admin/banners",
		component: AdminBanners
	},
	{
		path: "/admin/promos",
		component: AdminPromos
	},
	{
		path: "/admin/receipt",
		component: AdminReceiptOptions
	},
	{
		path: "/admin/taxes",
		component: AdminTaxes
	},

	// Not found
	{
		component: () => <h1 className="no-margin">Page not found</h1>
	}
];



// WEBPACK FOOTER //
// ./src/components/admin/adminRoutes.js